import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Dropdown from "react-bootstrap/Dropdown";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import ErrorDisplay from "member/components/ErrorDisplay";
import * as bookmarkFoldersActions from "member/redux/modules/bookmarkFolders";
import * as searchResultActions from "member/redux/modules/searchResults";
import { usePowerSearch } from "../contexts/power-search-context";
import { printReport } from "shared/utilities";
import "../styles/result-card-grid.css";
import { mixpanelTrack } from "shared/trackEvents/mixpanelTracking";
import { isOpenRemunerationPlan } from "shared/plans";
import { POWER_SEARCH_EVENT_NAMES } from "shared/trackEvents/constants";

const addToPowerList = (createPowerList, powerListCreating, options, cb) => {
  if (!powerListCreating) {
    createPowerList(options, cb);
  }
};

export const ExtraActions = () => {
  const [showModal, setShowModal] = useState(false);
  const [listName, setListName] = useState("");
  const [dropdownShow, setDropdownShow] = useState(false);

  const dispatch = useDispatch();

  const {
    fetchAllResultsForPrinting,
    printing,
    allSearchResultsLoading,
    allSearchResults,
    currentUser,
  } = usePowerSearch();

  // Redux selectors
  const { powerListCreating, powerListCreated, errors } = useSelector(
    (state) => state.bookmarkFolders
  );
  const { all_search_results } = useSelector(
    (state) => state.searchResults.all_result
  );

  const bookmarkableIDs = allSearchResults.map((f) => f.id);
  const bookmarkableType = "Director";

  const showModalHandler = () => {
    if (!powerListCreated) {
      setShowModal(true);
    }
  };

  const saveList = () => {
    if (listName) {
      const options = {
        title: listName,
        description: "Created from Power Search Result",
        bookmarks_attributes: bookmarkableIDs.map((id) => {
          return {
            bookmarkable_id: id,
            bookmarkable_type: bookmarkableType,
          };
        }),
      };

      addToPowerList(
        (options, cb) =>
          dispatch(bookmarkFoldersActions.createPowerList(options, cb)),
        powerListCreating,
        {
          bookmark_folder: options,
        },
        () => {
          if (errors.length === 0) {
            setShowModal(false);
          }
        }
      );
    }
  };

  const handleLoaded = () => {
    if (listName) {
      saveList();
    }
  };

  const handlePrint = () => {
    fetchAllResultsForPrinting(() => {
      printReport(
        "BylrKmBQrL",
        "Search Result.pdf",
        { search_results: allSearchResults },
        () => {},
        () => {},
        currentUser?.email
      );
    });
  };

  const handleDropdownToggle = (isOpen) => {
    // Don't close dropdown if fetching or printing
    if (isOpen || (!allSearchResultsLoading && !printing)) {
      setDropdownShow(isOpen);
    }
  };

  const handleSaveClick = (e) => {
    // Prevent dropdown from closing during loading states
    if (powerListCreating || allSearchResultsLoading) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    // Track add to list click
    const eventName = isOpenRemunerationPlan(currentUser)
      ? POWER_SEARCH_EVENT_NAMES.OR_POWER_SEARCH_ADD_TO_LIST_CLICKED
      : POWER_SEARCH_EVENT_NAMES.OD_POWER_SEARCH_ADD_TO_LIST_CLICKED;

    mixpanelTrack(eventName, {
      userEmail: currentUser?.email,
    });

    showModalHandler();
  };

  const handlePrintClick = (e) => {
    // Prevent dropdown from closing during loading states
    if (allSearchResultsLoading || printing) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    handlePrint();
  };

  return (
    <>
      <Dropdown
        className="extra-actions-dropdown"
        show={dropdownShow}
        onToggle={handleDropdownToggle}
      >
        <Dropdown.Toggle
          variant="secondary"
          id="results-actions-dropdown"
          size="sm"
          className="extra-actions-toggle"
        >
          Actions
        </Dropdown.Toggle>
        <Dropdown.Menu className="extra-actions-menu p-2">
          <Dropdown.Item
            className="print-result-item"
            onClick={handleSaveClick}
          >
            <i className="fa fa-plus mr-2" />
            {powerListCreating
              ? "Saving..."
              : powerListCreated
              ? "View in lists"
              : "Save Result"}
          </Dropdown.Item>
          {/* <Dropdown.Item
            onClick={handlePrintClick}
            disabled={allSearchResultsLoading || printing}
            className="print-result-item"
          >
            <i className="fa fa-print mr-2" />
            {printing
              ? "Generating Report..."
              : allSearchResultsLoading
              ? "Fetching..."
              : "Print first 5 pages results"}
          </Dropdown.Item> */}
        </Dropdown.Menu>
      </Dropdown>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>List Name</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ErrorDisplay errors={errors} />
          <Form.Control
            as="input"
            placeholder="My awesome list"
            onChange={(e) => {
              setListName(e.target.value);
            }}
            value={listName}
          />
          <Modal.Footer>
            {allSearchResultsLoading && (
              <Button variant="secondary">Fetching all results...</Button>
            )}
            {!allSearchResultsLoading && (
              <Button variant="primary" onClick={(e) => handleLoaded()}>
                Save
              </Button>
            )}
          </Modal.Footer>
        </Modal.Body>
      </Modal>
    </>
  );
};
